import { QueryParamsEnum } from '@honeycomb/data';
import { QueryParamManager } from '../utils/QueryParamManager';
import { router } from '../utils/router';
export function flightSelectRoute({ selectFlightResults, routeToExtrasPage = false, }) {
    const { selectFlight } = selectFlightResults !== null && selectFlightResults !== void 0 ? selectFlightResults : {};
    const tripStateId = selectFlight === null || selectFlight === void 0 ? void 0 : selectFlight.tripStateId;
    const newRoute = routeToExtrasPage ? '/flights/options' : '/booking/passengers';
    const paramManager = new QueryParamManager(newRoute, router.currentParams());
    paramManager.remove(QueryParamsEnum.TRIP_STATE_ID);
    if (tripStateId) {
        paramManager.add(QueryParamsEnum.TRIP_STATE_ID, tripStateId);
    }
    return [paramManager.toString(), undefined, { shallow: true }];
}
export function flightSelectedRouting(params) {
    if (params) {
        router.push(params, flightSelectRoute);
    }
}
